import type { ReactNode } from 'react'

/**
 * A member's name inside a sentence — the greeting, the Mat Bot title, the
 * founders in the Library hero.
 *
 * Branding decision D5 (punch-list item 1): the name is set in the SAME style
 * as the sentence around it. No italic, no Doré, no weight change — the
 * heading's face, weight and colour are inherited and nothing is added.
 *
 * It used to be an italic, Doré-coloured `<em>`. Two things were
 * wrong with that at once: Rosario's italic face was never loaded, so the
 * browser obliqued the upright one and the client read it as a "script
 * font"; and Doré text on amande is 2.6:1, so the one word on the page that
 * is about the member was the least readable word on it.
 *
 * A `<span>` rather than an `<em>`: emphasis is exactly what the design no
 * longer wants, and a screen reader that honours `<em>` would stress the
 * name. This is the one component every name-in-sentence goes through, so
 * `member-name.test.tsx` can assert the rule once.
 */
export function MemberName({ children }: { children?: ReactNode }) {
  return <span data-member-name>{children}</span>
}
